import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormGroupType } from '../../../../../../core/models/form-group-type';
import { GoApplicationRequestFormModel } from '../../models/go-application-request-form-model';
import { FormGroup } from '@angular/forms';
import { GoApplicationSummaryService } from '../../services/go-application-summary/go-application-summary.service';
import { CommonModule } from '@angular/common';
import { tryParseToNumber } from '../../../../../../core/functions/string-helpers';

@Component({
    selector: 'app-go-parameters-summary',
    imports: [MatExpansionModule, CommonModule],
    templateUrl: './go-parameters-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './go-parameters-summary.component.scss',
})
export class GoParametersSummaryComponent {
    @Input() form!: FormGroup<FormGroupType<GoApplicationRequestFormModel>>;
    @Input() expanded: boolean = true;
    @Input() hideToggle: boolean = false;
    @Input() disabled: boolean = false;

    constructor(
        private readonly goApplicationSummaryService: GoApplicationSummaryService,
    ) {}

    get frequencyTypeTitle(): string | null {
        return this.goApplicationSummaryService.getFrequencyTypeTitle(
            'summary',
        );
    }

    get frequencyTypeSummary(): string | null {
        return this.goApplicationSummaryService.getFrequencyTypeValueSummary(
            this.form.controls.frequencyType.value,
        );
    }

    get locationTypeTitle(): string | null {
        return this.goApplicationSummaryService.getLocationTypeTitle('summary');
    }

    get locationTypeSummary(): string | null {
        return this.goApplicationSummaryService.getLocationTypeValueSummary(
            this.form.controls.locationType.value,
        );
    }

    get stationClassTitle(): string | null {
        return this.goApplicationSummaryService.getStationClassTitle('summary');
    }

    get stationClassSummary(): string | null {
        return this.goApplicationSummaryService.getStationClassValueSummary(
            this.form.controls.stationClassType.value,
            this.form.controls.dataDirectionType.value,
            '<br/>',
        );
    }

    get numberOfFrequenciesTitle(): string | null {
        return this.goApplicationSummaryService.getNumberOfFrequenciesTitle(
            'summary',
        );
    }

    get numberOfFrequenciesSummary(): string | null {
        return this.goApplicationSummaryService.getNumberOfFrequenciesSummaryPageText(
            this.form.controls.numberOfFrequencies.value,
        );
    }

    get coordinatesTitle(): string | null {
        return this.goApplicationSummaryService.getCoordinatesTitle('summary');
    }

    get coordinatesSummary(): string | null {
        return this.goApplicationSummaryService.getCoordinatesValueSummary(
            tryParseToNumber(this.form.controls.latitude.value),
            tryParseToNumber(this.form.controls.longitude.value),
            '<br/>',
            this.form.controls.towerRegistrationNumber.value ?? undefined,
        );
    }

    get antennaHeightTitle(): string | null {
        return this.goApplicationSummaryService.getAntennaHeightTitle(
            'summary',
        );
    }

    get antennaHeightSummary(): string | null {
        return this.goApplicationSummaryService.getAntennaHeightValueSummary(
            this.form.controls.locationType.value,
            this.form.controls.antennaHeightUnitType.value,
            this.form.controls.heightToTip.value,
        );
    }

    get minimumErpRequiredTitle(): string | null {
        return this.goApplicationSummaryService.getMinimumErpRequiredTitle(
            'summary',
        );
    }

    get minimumErpRequiredSummary(): string | null {
        return this.goApplicationSummaryService.getMinimumErpRequiredValueSummary(
            this.form.controls.fixedErp.value,
            this.form.controls.mobileErp.value,
            '<br/>',
            ' watts',
        );
    }

    get emissionDesignatorTitle(): string | null {
        return this.goApplicationSummaryService.getEmissionDesignatorTitle(
            'summary',
        );
    }

    get emissionDesignatorSummary(): string | null {
        return this.goApplicationSummaryService.getEmissionDesignatorValueSummary(
            this.form.controls.emissionDesignatorPowerType.value,
            this.form.controls.emissionDesignatorInformationType.value,
        );
    }
}
